var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button } from 'semantic-ui-react';
import React from 'react';
import queryString from 'querystring';
import userApi from 'app/apis/user';
import * as Sentry from '@sentry/browser';
import CheckIcon from 'components/Icons/CheckIcon';
import NextIcon from 'components/Icons/NextIcon';
import { getCompany, getFirstName, getLastName } from 'app/helpers/userHelper';
import constants from 'app/constants/global-constants';
export var handleLeadGeneration = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, hash, localStorageHash, marketoUtmObject, _a, er, res;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                accessToken = data.accessToken;
                hash = queryString.parse(window.location.search);
                localStorageHash = window.localStorage && localStorage.getItem('sandboxUrlHash');
                localStorageHash =
                    window.localStorage && localStorage.getItem('sandboxUrlHash')
                        ? JSON.parse(localStorageHash)
                        : {};
                marketoUtmObject = {
                    utmSource: hash.utm_source || localStorageHash.utm_source || null,
                    utmMedium: hash.utm_medium || localStorageHash.utm_medium || null,
                    utmCampaign: hash.utm_campaign || localStorageHash.utm_campaign || null,
                    utmTerm: hash.utm_term || localStorageHash.utm_term || null,
                    utmAdGroup: hash.utm_adgroup || localStorageHash.utm_adgroup || null,
                    utmContent: hash.utm_content || localStorageHash.utm_content || null,
                    utmProgram: hash.program_name ||
                        hash.utm_program ||
                        localStorageHash.program_name ||
                        localStorageHash.utm_program ||
                        null,
                    utmOriginal: window.location.search,
                    gclid: hash.gclid || localStorageHash.gclid || null,
                };
                return [4 /*yield*/, userApi.addConditionalLead(marketoUtmObject, accessToken)];
            case 1:
                _a = _b.sent(), er = _a[0], res = _a[1];
                if (!er && res.status !== 200) {
                    Sentry.captureMessage('Something wrong with addConditionalLead function');
                }
                return [2 /*return*/, true];
        }
    });
}); };
export var getFieldsToShow = function (userProfile) {
    var fieldsToShow = [];
    if (!getFirstName(userProfile))
        fieldsToShow.push(constants.keys.FIRST_NAME);
    if (!getLastName(userProfile))
        fieldsToShow.push(constants.keys.LAST_NAME);
    if (!getCompany(userProfile))
        fieldsToShow.push(constants.keys.COMPANY);
    return fieldsToShow;
};
export var OnboardingFlowButton = function (props) {
    var currentStepIndex = props.currentStepIndex, totalSteps = props.totalSteps, onClick = props.onClick, isDisabled = props.isDisabled, isLoading = props.isLoading;
    return (React.createElement("div", { className: "mt5 text-right" },
        React.createElement(Button, { onClick: onClick, color: "blue", disabled: isDisabled, loading: isLoading, style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } }, currentStepIndex && totalSteps && currentStepIndex + 1 === totalSteps ? (React.createElement("span", null,
            React.createElement("span", { style: { paddingRight: 8 } }, "Complete"),
            " ",
            React.createElement(CheckIcon, { viewBox: undefined }))) : (React.createElement(React.Fragment, null,
            React.createElement("span", { style: { paddingRight: 8 } }, "Next"),
            React.createElement(NextIcon, { size: 12, strokeWidth: 3 }))))));
};
export var purposeOptions = [
    {
        key: 'curious',
        value: 'Curious',
        text: 'I am curious about graph databases',
    },
    {
        key: 'learn',
        value: 'Learn',
        text: 'I want to actively learn about graph databases',
    },
    {
        key: 'solve a problem',
        value: 'Solve a problem',
        text: 'I am looking to solve a problem and graph databases might be a solution',
    },
    {
        key: 'competitive-evaluation',
        value: 'Competitive	evaluation',
        text: 'I am comparing Neo4j to other graph databases',
        shouldShowCompetitorsQuestion: true,
    },
    {
        key: 'training',
        value: 'Training',
        text: 'I am doing a Neo4j Training class',
    },
    {
        key: 'other',
        value: 'other',
        text: 'Other',
    },
];
export var graphKnowledgeOptions = [
    {
        key: 'nothing-or-little',
        value: 'Nothing or little',
        text: 'I am new or know very little',
    },
    {
        key: 'basic',
        value: 'Basic',
        text: 'I know some graph concepts, but have never used a graph database before',
    },
    {
        key: 'intermediate',
        value: 'Intermediate',
        text: 'I have used a graph database before',
        shouldShowCompetitorsQuestion: true,
    },
];
export var competitorsOptionsList = [
    {
        key: 'TigerGraph',
        value: 'TigerGraph',
        text: 'TigerGraph',
    },
    {
        key: 'DGraph',
        value: 'DGraph',
        text: 'DGraph',
    },
    {
        key: 'AWS Neptune',
        value: 'AWS Neptune',
        text: 'AWS Neptune',
    },
    {
        key: 'ArangoDB',
        value: 'ArangoDB',
        text: 'ArangoDB',
    },
    {
        key: 'OrientDB',
        value: 'OrientDB',
        text: 'OrientDB',
    },
    {
        key: 'CosmosDB',
        value: 'CosmosDB',
        text: 'CosmosDB',
    },
    {
        key: 'Others',
        value: 'Others',
        text: 'Others',
    },
    {
        key: 'None',
        value: 'None',
        text: 'None',
    },
];
